import { LogService } from '../app/shared/services/log.service';

export const environment = {
  production: false,
  apiUrl: 'https://test.app.mediget.org/api/v1/',
  apiUrlStorage: 'https://test.app.mediget.org/api/v1/',
  user: '',
  password: '',
  logLevel: LogService.WARNING,
  sentry: {
    endpoint: 'https://91529e24c332491aa7b30a80ff558a01@o641846.ingest.sentry.io/5780516',
    tracingURLs: ['https://test.app.mediget.org/api/v1/']
  },
  firebase: {
    apiKey: "AIzaSyDydvq5yy0P6d15nTWYsXe38QEVhZje92A",
    authDomain: "mediget-prod.firebaseapp.com",
    projectId: "mediget-prod",
    storageBucket: "mediget-prod.appspot.com",
    messagingSenderId: "647645572525",
    appId: "1:647645572525:web:fdc3b8e31474f967950524",
    measurementId: "G-49ZCJGMHEF",
  },
};
